import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor() {}

  saveToken(token: string): void {
    // Salva il token nel localStorage
    localStorage.setItem('authToken', token);
  }

  getToken(): string | null {
    // Recupera il token dal localStorage
    return localStorage.getItem('authToken');
  }

  removeToken(): void {
    // Rimuove il token dal localStorage
    localStorage.removeItem('authToken');
  }

  logout(): void {
    // Rimuove il token dal localStorage
    localStorage.removeItem('authToken');
  }
}
